export default "__VITE_ASSET__CmIymLUT__"